import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface NotificationSettings {
  email: boolean;
  sms: boolean;
  push: boolean;
  homework: boolean;
  attendance: boolean;
  grades: boolean;
  events: boolean;
  payments: boolean;
}

interface ProfileData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  address: string;
  relationship: string;
}

const ParentSettings = () => {
  const routes = all_routes;
  const [activeSection, setActiveSection] = useState("profile");

  const [profileData, setProfileData] = useState<ProfileData>({
    firstName: "John",
    lastName: "Johnson",
    email: "john.johnson@email.com",
    phone: "+1 234 567 8900",
    address: "123 Main Street, City, State 12345",
    relationship: "Father",
  });

  const [notifications, setNotifications] = useState<NotificationSettings>({
    email: true,
    sms: false,
    push: true,
    homework: true,
    attendance: true,
    grades: true,
    events: false,
    payments: true,
  });

  const [language, setLanguage] = useState("en");
  const [theme, setTheme] = useState("light");

  const handleProfileSave = () => {
    // TODO: Save profile API call
    alert("Profile updated successfully!");
  };

  const handleNotificationChange = (key: keyof NotificationSettings) => {
    setNotifications((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const renderProfileSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Profile Information</h5>
      </div>
      <div className="card-body">
        <form>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">First Name</label>
              <input
                type="text"
                className="form-control"
                value={profileData.firstName}
                onChange={(e) =>
                  setProfileData((prev) => ({
                    ...prev,
                    firstName: e.target.value,
                  }))
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Last Name</label>
              <input
                type="text"
                className="form-control"
                value={profileData.lastName}
                onChange={(e) =>
                  setProfileData((prev) => ({
                    ...prev,
                    lastName: e.target.value,
                  }))
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                className="form-control"
                value={profileData.email}
                onChange={(e) =>
                  setProfileData((prev) => ({ ...prev, email: e.target.value }))
                }
              />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Phone</label>
              <input
                type="tel"
                className="form-control"
                value={profileData.phone}
                onChange={(e) =>
                  setProfileData((prev) => ({ ...prev, phone: e.target.value }))
                }
              />
            </div>
          </div>
          <div className="mb-3">
            <label className="form-label">Address</label>
            <textarea
              className="form-control"
              rows={3}
              value={profileData.address}
              onChange={(e) =>
                setProfileData((prev) => ({ ...prev, address: e.target.value }))
              }
            ></textarea>
          </div>
          <div className="mb-3">
            <label className="form-label">Relationship to Student</label>
            <select
              className="form-select"
              value={profileData.relationship}
              onChange={(e) =>
                setProfileData((prev) => ({
                  ...prev,
                  relationship: e.target.value,
                }))
              }
            >
              <option value="Father">Father</option>
              <option value="Mother">Mother</option>
              <option value="Guardian">Guardian</option>
              <option value="Other">Other</option>
            </select>
          </div>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleProfileSave}
          >
            <i className="ti ti-device-floppy me-2"></i>
            Save Changes
          </button>
        </form>
      </div>
    </div>
  );

  const renderNotificationSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Notification Preferences</h5>
      </div>
      <div className="card-body">
        <div className="row mb-4">
          <div className="col-md-4">
            <h6>Delivery Methods</h6>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={notifications.email}
                onChange={() => handleNotificationChange("email")}
                id="emailNotif"
              />
              <label className="form-check-label" htmlFor="emailNotif">
                Email Notifications
              </label>
            </div>
            <div className="form-check mb-2">
              <input
                className="form-check-input"
                type="checkbox"
                checked={notifications.sms}
                onChange={() => handleNotificationChange("sms")}
                id="smsNotif"
              />
              <label className="form-check-label" htmlFor="smsNotif">
                SMS Notifications
              </label>
            </div>
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={notifications.push}
                onChange={() => handleNotificationChange("push")}
                id="pushNotif"
              />
              <label className="form-check-label" htmlFor="pushNotif">
                Push Notifications
              </label>
            </div>
          </div>
          <div className="col-md-8">
            <h6>Notification Types</h6>
            <div className="row">
              <div className="col-md-6">
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={notifications.homework}
                    onChange={() => handleNotificationChange("homework")}
                    id="homeworkNotif"
                  />
                  <label className="form-check-label" htmlFor="homeworkNotif">
                    Homework Updates
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={notifications.attendance}
                    onChange={() => handleNotificationChange("attendance")}
                    id="attendanceNotif"
                  />
                  <label className="form-check-label" htmlFor="attendanceNotif">
                    Attendance Alerts
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={notifications.grades}
                    onChange={() => handleNotificationChange("grades")}
                    id="gradesNotif"
                  />
                  <label className="form-check-label" htmlFor="gradesNotif">
                    Grade Updates
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={notifications.events}
                    onChange={() => handleNotificationChange("events")}
                    id="eventsNotif"
                  />
                  <label className="form-check-label" htmlFor="eventsNotif">
                    School Events
                  </label>
                </div>
                <div className="form-check mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={notifications.payments}
                    onChange={() => handleNotificationChange("payments")}
                    id="paymentsNotif"
                  />
                  <label className="form-check-label" htmlFor="paymentsNotif">
                    Payment Reminders
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="button" className="btn btn-primary">
          <i className="ti ti-device-floppy me-2"></i>
          Save Preferences
        </button>
      </div>
    </div>
  );

  const renderAppearanceSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Appearance & Language</h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Language</label>
            <select
              className="form-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="en">English</option>
              <option value="es">Español</option>
              <option value="fr">Français</option>
              <option value="de">Deutsch</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Theme</label>
            <select
              className="form-select"
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
              <option value="auto">Auto</option>
            </select>
          </div>
        </div>
        <button type="button" className="btn btn-primary">
          <i className="ti ti-device-floppy me-2"></i>
          Save Settings
        </button>
      </div>
    </div>
  );

  const renderSecuritySettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Security & Privacy</h5>
      </div>
      <div className="card-body">
        <div className="mb-4">
          <h6>Change Password</h6>
          <form>
            <div className="mb-3">
              <label className="form-label">Current Password</label>
              <input type="password" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">New Password</label>
              <input type="password" className="form-control" />
            </div>
            <div className="mb-3">
              <label className="form-label">Confirm New Password</label>
              <input type="password" className="form-control" />
            </div>
            <button type="button" className="btn btn-warning">
              <i className="ti ti-lock me-2"></i>
              Change Password
            </button>
          </form>
        </div>
        <hr />
        <div className="mb-4">
          <h6>Privacy Settings</h6>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              defaultChecked
              id="profileVisible"
            />
            <label className="form-check-label" htmlFor="profileVisible">
              Allow teachers to view my contact information
            </label>
          </div>
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="dataSharing"
            />
            <label className="form-check-label" htmlFor="dataSharing">
              Allow anonymous data usage for school analytics
            </label>
          </div>
        </div>
        <hr />
        <div>
          <h6 className="text-danger">Danger Zone</h6>
          <p className="text-muted small">
            Once you delete your account, all data associated with it will be
            permanently removed.
          </p>
          <button type="button" className="btn btn-outline-danger">
            <i className="ti ti-trash me-2"></i>
            Delete Account
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Settings</h3>
              <p className="text-muted mb-0">Manage your account preferences</p>
            </div>
          </div>

          {/* Settings Navigation */}
          <div className="row">
            <div className="col-md-3 mb-4">
              <div className="card">
                <div className="card-body p-2">
                  <nav className="nav nav-pills flex-column">
                    <button
                      className={`nav-link text-start ${
                        activeSection === "profile" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("profile")}
                    >
                      <i className="ti ti-user me-2"></i>
                      Profile
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "notifications" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("notifications")}
                    >
                      <i className="ti ti-bell me-2"></i>
                      Notifications
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "appearance" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("appearance")}
                    >
                      <i className="ti ti-palette me-2"></i>
                      Appearance
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "security" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("security")}
                    >
                      <i className="ti ti-shield me-2"></i>
                      Security
                    </button>
                  </nav>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              {activeSection === "profile" && renderProfileSettings()}
              {activeSection === "notifications" &&
                renderNotificationSettings()}
              {activeSection === "appearance" && renderAppearanceSettings()}
              {activeSection === "security" && renderSecuritySettings()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ParentSettings;
